import { Route, Routes } from 'react-router-dom';

import RouteWithTitle from '../../../../src/routes/RouteWithTitle';
import RouteGuard from '../../../routes/RouteGuard';
import TaskListing from '../TaskListing';

export const TaskRoutes = () => (
  <Routes>
    <Route
      path="/"
      element={
        <RouteWithTitle title="Reminders - Wisestep">
          <RouteGuard>
            <TaskListing />
          </RouteGuard>
        </RouteWithTitle>
      }
    />
    <Route
      path="/:candidateEmail"
      element={
        <RouteWithTitle title="Reminders - Wisestep">
          <RouteGuard>
            <TaskListing />
          </RouteGuard>
        </RouteWithTitle>
      }
    />
  </Routes>
);
